export default __webpack_public_path__ + "static/android-wear-apple-39a96e061bd9e8de908f21c8071312b8.webp";